module.exports = __webpack_public_path__ + "static/media/users-icon.b9c82d28.svg";